<template>
  <el-select class="picker" size="small" v-model="locationSelected" placeholder="select location" @change="locationChange">
    <el-option
      v-for="loc in locations"
      :key="loc.value"
      :label="loc.label"
      :value="loc.value">
    </el-option>
  </el-select>
</template>


<script>

export default {
  name: 'locationPicker',
  props: [ 'location' ],
  data() {
    return {
      locationSelected: this.location,
    }
  },
  computed: {
    locations() {
      let heartbeats = this.$store.state.availability.heartbeats 
      let locations = []
      ;([ "winston", "greensboro" ]).forEach( loc => {
        if ( heartbeats[ loc ] ) {
          let loc_obj = {
            value: loc,
            label: loc.charAt(0).toUpperCase() + loc.slice(1),
          }

          locations.push( loc_obj )
        }
      } )
      
      if ( !heartbeats[ this.locationSelected ] ) {
        this.locationSelected = null
        this.$store.commit( "availability/UPDATE_LOCATION", null )
      } 

      return locations
    }
  },
  methods: {
    locationChange( loc ) {
      this.$emit( 'locationChange', loc )
    }
  }
}

</script>

<style lang="scss" scoped>
.picker {
  float: left;
  clear: left;
  width: 150px !important;
  @media screen and (max-width: 768px) {
    width: 100%;
    width: 95% !important;
  }
  @media screen and (max-width: 425px) {
    width: 100% !important;
  }
}
</style>